/* eslint-disable radix */

import {
    Grid,
    IconButton,
    Select,
    MenuItem,
    SelectChangeEvent,
} from '@mui/material';

import React from 'react';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { setMonth, getMonth, setYear, getYear } from 'date-fns';

interface HeaderProps {
    date: Date;
    setDate: (date: Date) => void;
    nextDisabled: boolean;
    prevDisabled: boolean;
    onClickNext: () => void;
    onClickPrevious: () => void;
}

const MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
];

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const generateYears = (relativeTo: Date, count: number) => {
    const half = Math.floor(count / 2);
    return Array(count)
        .fill(0)
        .map((_y, i) => relativeTo.getFullYear() - half + i); // TODO: make part of the state
};

const Header: React.FunctionComponent<HeaderProps> = ({
    date,
    setDate,
    nextDisabled,
    prevDisabled,
    onClickNext,
    onClickPrevious,
}: HeaderProps) => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleMonthChange = (event: SelectChangeEvent<number>) => {
        setDate(
            setMonth(
                date,
                typeof event.target.value === 'string'
                    ? parseInt(event.target.value)
                    : event.target.value
            )
        );
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleYearChange = (event: SelectChangeEvent<number>) => {
        setDate(
            setYear(
                date,
                typeof event.target.value === 'string'
                    ? parseInt(event.target.value)
                    : event.target.value
            )
        );
    };

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid item className="iconContainer">
                <IconButton
                    className="icon-header"
                    disabled={prevDisabled}
                    onClick={onClickPrevious}
                    title="prev"
                >
                    <ChevronLeft color={prevDisabled ? 'disabled' : 'action'} />
                </IconButton>
            </Grid>
            <Grid item>
                <Select
                    className="select-format"
                    value={getMonth(date)}
                    onChange={handleMonthChange}
                    MenuProps={{ disablePortal: false }}
                >
                    {MONTHS.map((month, idx) => (
                        <MenuItem key={month} value={idx}>
                            {month}
                        </MenuItem>
                    ))}
                </Select>
            </Grid>

            <Grid item>
                <Select
                    className="select-format"
                    value={getYear(date)}
                    onChange={handleYearChange}
                    MenuProps={{ disablePortal: false }}
                >
                    {generateYears(date, 30).map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                </Select>

                {/* <Typography>{format(date, "MMMM YYYY")}</Typography> */}
            </Grid>
            <Grid item className="iconContainer">
                <IconButton
                    className="icon-header"
                    disabled={nextDisabled}
                    onClick={onClickNext}
                    title="next"
                >
                    <ChevronRight
                        color={nextDisabled ? 'disabled' : 'action'}
                    />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default Header;
